import { trpc } from '@/config/trpc'
import { useEffect, useState } from 'react'
import { usePostHog } from 'posthog-js/react'

type Props = {
  email: string
  onSwitchToLogin: () => void
}

export function VerificationRequired({ email, onSwitchToLogin }: Props) {
  const posthog = usePostHog()
  const [isSent, setIsSent] = useState(false)
  const [error, setError] = useState('')

  const { mutateAsync: resendVerifyToken, isPending } =
    trpc.auth.resendVerificationToken.useMutation({
      onError: (error) => setError(error.message),
    })

  useEffect(() => {
    if (!email) {
      onSwitchToLogin()
    }
  }, [email, onSwitchToLogin])

  const handleResend = async (e: React.MouseEvent) => {
    e.preventDefault()

    if (isPending) return

    setError('')

    posthog.capture('auth_resend_verification_requested')
    await resendVerifyToken({ email })
    setIsSent(true)
  }
  return (
    <div className="flex flex-col items-center gap-4">
      {isSent ? (
        <p className="text-center text-sm sm:text-base">
          Verification email sent! Please check your inbox.
        </p>
      ) : isPending ? (
        <div className="flex items-center justify-center">
          <div className="border-primary/30 border-t-primary h-6 w-6 animate-spin rounded-full border-4"></div>
        </div>
      ) : (
        <div className="space-y-2 text-center">
          <p className="text-center text-sm sm:text-base">
            Please verify your email address to log in.
          </p>
          <p className="text-center text-sm sm:text-base">
            If you haven't received a verification email, please check your spam folder or
          </p>
          <a
            className="text-primary cursor-pointer text-center text-sm underline sm:text-base"
            onClick={handleResend}>
            click here
          </a>
          <p className="text-center text-sm sm:text-base">to resend the verification email.</p>
        </div>
      )}

      {error && <span className="text-destructive-foreground mb-2 text-xs">{error}</span>}

      <p className="text-muted-foreground mt-2 text-center text-xs">
        Back to{' '}
        <a
          className="text-primary cursor-pointer underline"
          onClick={(e) => {
            e.preventDefault()
            onSwitchToLogin()
          }}>
          Login
        </a>
        .
      </p>
    </div>
  )
}
